import Button from '@components/elements/Button';
import Modal from '@components/elements/Modal';
import { T } from 'react-translator-component';
import { RowsProp } from './TermTable';
import { noticeIcon } from '@assets/icons';

type ModalProps = {
  term: RowsProp | any,
  amount: string,
  handleConfirm: (term: RowsProp) => void,
  handleClose: () => void,
}

const ConfirmModal = ({ term, amount, handleConfirm, handleClose }: ModalProps) => {
  return <Modal
    modalClose={handleClose}
    title={T('Review Earning Term')}
    modalBody={<div className="text-grey-100">
      <div
        className="w-20 md:w-24 h-20 md:h-24 mx-auto my-5 rounded-full flex items-center justify-center bg-primary">
        <img
          src={noticeIcon}
          height={40}
          width={40}
          alt="alert icon"
        />
      </div>
      <div className="mt-4">{T('You are going to deposit TiFi Tokens with the following term:')}</div>
      <div className="ml-4">
        <li><span>{T('Deposit Amount: ')}</span><span className="text-white">{amount} {T('TIFI')}</span></li>
        <li><span>{T('Deposit Period: ')}</span><span className="text-white">{term.period} {T('Days')}</span></li>
        <li><span>{T('Reward: ')}</span><span className="text-white">{`${term.rate * 100} %`} {T(' and reflection rewards')}</span></li>
      </div>
      <div className="mb-8 mt-4">{T('By clicking the button below, I acknowledged that above terms cannot be changed AND I am not able to withdraw the principal or rewards during the period show above.')}</div>
      <Button
        onClick={() => handleConfirm(term)}
        label={T('Accept and Deposit')}
        className="text-xs bg-primary rounded-[10px] text-white" />
    </div>} />
};

export default ConfirmModal;